import { CommentLinkDialogCloseButton } from './CommentLinkDialogCloseButton';
import { CommentLinkDialogCopyLink } from './CommentLinkDialogCopyLink';
import { CommentLinkDialogInput } from './CommentLinkDialogInput';

export const CommentLinkDialog = {
  CloseButton: CommentLinkDialogCloseButton,
  CopyLink: CommentLinkDialogCopyLink,
  Input: CommentLinkDialogInput,
};
